export const maxImageSizeInBytes: number = 1000000; // 1 MB